export const listStyle = {
  borderRadius: '1rem!important',
  background: 'rgba(255, 255, 255, 0.2)',
  width: '100%',
  padding: '1rem',
};
export const listItemStyle = {
  display: 'flex',
};
